<div
  [ngClass]="{
    ' mb-7': !singleView(),
    'shadow-none border-top-0 border-right-0 border-left-0 border-1 border-bottom rounded-0':
      singleView(),
  }"
  class="card overflow-hidden"
>
  <div class="card-body pt-0 pb-0 overflow-x-auto overflow-y-hidden ps-7">
    <ul
      class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap"
    >
      @for (tab of tabs(); track tab) {
        <li class="nav-item">
          @if (!tab?.visible) {
            <a
              class="nav-link text-active-primary ms-0 me-5 py-3 d-flex gap-1 align-items-center whitespace-nowrap"
              [routerLink]="[tab.link]"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="
                tab.routerLinkActiveOptions || { exact: true }
              "
            >
              {{ t() ? t()!(tab.label) : (tab.label | transloco) }}
              @if (tab?.count) {
                <span
                  class="d-flex align-items-center justify-content-center badge-count"
                >
                  {{ tab.count }}
                </span>
              }
              @if (tab?.tooltip) {
                <span
                  class="d-flex align-items-center justify-content-center"
                  [ngbTooltip]="
                    t() ? t()!(tab.tooltip!) : (tab.tooltip | transloco)
                  "
                  [placement]="'top'"
                  [container]="'body'"
                >
                  <ui-keenicon name="information" class="fs-4"></ui-keenicon>
                </span>
              }
            </a>
          }
        </li>
      }
    </ul>
  </div>
</div>
